import React, { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { X, ChevronUp } from 'react-bootstrap-icons';
import cnamgsCover from "../assets/img/IMG_20251211_123312_634.jpg";
import cnamgsCover1 from "../assets/img/engagement-parties-prenantes.jpg";
import cnamgsCover2 from "../assets/img/Cadres-CNAMGS.jpg";
import cnamgsCover3 from "../assets/img/R (1).jpg";
import cnamgsCover4 from "../assets/img/CNAMGS-3827-1.jpg";

const infoItems = [
  {
    id: 1,
    title: "Carte électronique",
    description: "Présentez votre carte chez tous les prestataires.",
    img: cnamgsCover,
  },
  {
    id: 2,
    title: "Prescriptions électroniques",
    description: "Simplifiez le suivi de vos ordonnances.",
    img: cnamgsCover1,
  },
  {
    id: 3,
    title: "Remboursements rapides",
    description: "Suivez vos remboursements en temps réel.",
    img: cnamgsCover2,
  },
  {
    id: 4,
    title: "Dossier médical centralisé",
    description: "Accédez à votre historique partout.",
    img: cnamgsCover3,
  },
  {
    id: 5,
    title: "Téléconsultation",
    description: "Consultez un médecin à distance.",
    img: cnamgsCover4,
  },
];

const InfoBar = () => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const saved = localStorage.getItem('infoBarHidden');
    if (saved === 'true') setVisible(false);
  }, []);

  const hideBar = () => {
    setVisible(false);
    localStorage.setItem('infoBarHidden', 'true');
  };

  const showBar = () => {
    setVisible(true);
    localStorage.setItem('infoBarHidden', 'false');
  };

  if (!visible) {
    return (
      <div className="info-bar-toggle" style={{
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        zIndex: 1050,
      }}>
        <Button
          onClick={showBar}
          className="rounded-circle p-0 shadow-lg"
          style={{
            width: '48px',
            height: '48px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            border: 'none',
            color: 'white',
            transition: 'transform 0.2s, box-shadow 0.2s',
            cursor: 'pointer',
          }}
          title="Afficher les actualités"
        >
          <ChevronUp size={24} />
        </Button>
      </div>
    );
  }

  return (
    <div className="info-bar" style={{
      position: 'fixed',
      bottom: '0',
      left: '280px',
      width: 'calc(100% - 280px)',
      background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
      borderTop: '1px solid rgba(0,0,0,0.06)',
      boxShadow: '0 -8px 30px rgba(0,0,0,0.06)',
      zIndex: 1040,
      overflow: 'hidden',
      height: '90px',
    }}>
      <Button
        onClick={hideBar}
        className="close-btn"
        style={{
          position: 'absolute',
          right: '20px',
          top: '50%',
          transform: 'translateY(-50%)',
          zIndex: 2,
          width: '36px',
          height: '36px',
          borderRadius: '50%',
          background: 'rgba(0,0,0,0.04)',
          backdropFilter: 'blur(4px)',
          border: '1px solid rgba(0,0,0,0.08)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#6c757d',
          padding: 0,
          transition: 'all 0.2s ease',
          cursor: 'pointer',
        }}
        title="Masquer"
      >
        <X size={18} />
      </Button>

      <div className="marquee-container" style={{
        display: 'flex',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        height: '100%',
        alignItems: 'center',
        marginRight: '80px',
      }}>
        <div className="marquee-content" style={{
          display: 'inline-flex',
          animation: 'marquee 55s linear infinite',
          alignItems: 'center',
          gap: '24px',
        }}>
          {[...infoItems, ...infoItems].map((item, idx) => (
            <div
              key={idx}
              className="info-card"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '16px',
                background: 'white',
                borderRadius: '20px',
                padding: '8px 28px 8px 12px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                transition: 'all 0.3s cubic-bezier(0.2, 0, 0, 1)',
                cursor: 'default',
                height: '70px',
                border: '1px solid rgba(0,0,0,0.04)',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-6px)';
                e.currentTarget.style.boxShadow = '0 16px 28px rgba(0,0,0,0.12)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.08)';
              }}
            >
              <img
                src={item.img}
                alt={item.title}
                style={{
                  width: '55px',
                  height: '50px',
                  objectFit: 'cover',
                  borderRadius: '14px',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                }}
              />
              <div>
                <strong style={{ fontSize: '1rem', display: 'block', color: '#1f2937', marginBottom: '6px', fontWeight: 600 }}>
                  {item.title}
                </strong>
                <span style={{ fontSize: '0.75rem', color: '#6b7280' }}>
                  {item.description}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .marquee-content {
          animation: marquee 55s linear infinite;
          will-change: transform;
        }
        .marquee-container:hover .marquee-content {
          animation-play-state: paused;
        }
        .close-btn:hover {
          background: rgba(0,0,0,0.1);
          transform: translateY(-50%) scale(1.08);
          color: #343a40;
        }
        .info-bar-toggle Button:hover {
          transform: scale(1.05);
          box-shadow: 0 8px 20px rgba(102,126,234,0.4);
        }
        @media (max-width: 768px) {
          .info-bar {
            left: 0 !important;
            width: 100% !important;
            height: 90px !important;
          }
          .info-bar-toggle {
            right: 20px !important;
            bottom: 20px !important;
          }
          .info-card {
            padding: 6px 16px 6px 8px !important;
            height: 75px !important;
            gap: 12px !important;
          }
          .info-card img {
            width: 55px !important;
            height: 55px !important;
          }
          .info-card strong {
            font-size: 0.85rem !important;
          }
          .info-card span {
            font-size: 0.65rem !important;
          }
        }
      `}</style>
    </div>
  );
};

const Footer = () => {
  return (
    <>
      <InfoBar />
      <div className="main-footer" style={{ marginTop: 'auto' }}>
        <span>© 2025 CNAMGS Digital. Tous droits réservés.</span>
        <span>CAISSE NATIONALE D'ASSURANCES MALADIES ET DE GARANTIE SOCIALE</span>
      </div>
    </>
  );
};

export default Footer;